// extracted by mini-css-extract-plugin
export default {"headerBar":"NewSharedDecision_headerBar__CBW8E"};